import { Children, ReactNode } from 'react';

import { Text, TextProps } from '@mantine/core';

interface FallbackTextProps extends TextProps {
  children?: ReactNode;
  fallback?: string;
}

const FallbackText = ({ children, fallback = '-', ...props }: FallbackTextProps) => {
  // Convert children to array and then join them into a single string
  const contentString = Children.toArray(children).join('').trim();

  // If the resulting string is empty, use "-"
  const displayContent = contentString === '' ? fallback : contentString;

  return <Text {...props}>{displayContent}</Text>;
};

export default FallbackText;
